import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  loginStartHour: 10,
  loginEndHour: 19,
  loading: false,
};

export const getLoginSettings = createAsyncThunk(
  "get-login-settings",
  async (_, { dispatch }) => {
    try {
      const response = await axios.get("settings/login-hours");
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateLoginSettings = createAsyncThunk(
  "update-login-settings",
  async (data, { dispatch }) => {
    try {
      const response = await axios.put("settings/login-hours", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLoginSettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(getLoginSettings.fulfilled, (state, action) => {
        state.loading = false;
        const s = action?.payload?.data?.data?.settings;
        if (s) {
          state.loginStartHour = s.loginStartHour;
          state.loginEndHour = s.loginEndHour;
        }
      })
      .addCase(getLoginSettings.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default settingsSlice.reducer;
